/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteTimelineConstraintTimeWindowDtoBase
 * auto generated base class for the model RouteTimelineConstraintTimeWindowDtoModel.
 */
export const RouteTimelineConstraintTimeWindowDtoModelBase = ModelBase
  .named('RouteTimelineConstraintTimeWindowDto')
  .props({
    __typename: types.optional(types.literal("RouteTimelineConstraintTimeWindowDto"), "RouteTimelineConstraintTimeWindowDto"),
    visitTimeWindowId: types.union(types.undefined, types.null, types.number),
    eventTimeWindowUuid: types.union(types.undefined, types.null, types.string),
    startTime: types.union(types.undefined, types.null, types.string),
    endTime: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteTimelineConstraintTimeWindowDtoModelSelector extends QueryBuilder {
  get visitTimeWindowId() { return this.__attr(`visitTimeWindowId`) }
  get eventTimeWindowUuid() { return this.__attr(`eventTimeWindowUuid`) }
  get startTime() { return this.__attr(`startTime`) }
  get endTime() { return this.__attr(`endTime`) }
}
export function selectFromRouteTimelineConstraintTimeWindowDto() {
  return new RouteTimelineConstraintTimeWindowDtoModelSelector()
}

export const routeTimelineConstraintTimeWindowDtoModelPrimitives = selectFromRouteTimelineConstraintTimeWindowDto().visitTimeWindowId.eventTimeWindowUuid.startTime.endTime
